import { defineComponent as _defineComponent } from 'vue';
import { toRef } from "vue";
import { useConfigurationTemplateCreation } from "@/components/ConfigTemplates/useConfigurationTesting";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateForm',
    props: {
        template: null,
        uuid: null
    },
    emits: ["created"],
    setup(__props, { emit }) {
        const props = __props;
        const createUrl = "/api/object_store_instances";
        const createTestUrl = "/api/object_store_instances/test";
        const title = "Create a new storage location for your data";
        const { ActionSummary, error, inputs, InstanceForm, onSubmit, submitTitle, loadingMessage, testRunning, testResults } = useConfigurationTemplateCreation("storage location", toRef(props, "template"), toRef(props, "uuid"), createTestUrl, createUrl, (instance) => emit("created", instance));
        return { __sfc: true, createUrl, createTestUrl, props, title, emit, ActionSummary, error, inputs, InstanceForm, onSubmit, submitTitle, loadingMessage, testRunning, testResults };
    }
});
